<div class="LayerLegend">
    <Legend v-if="legend != undefined" :config="legend" />
    <template v-else>Keine Legende verfügbar</template>
</div>

